module.exports = __webpack_public_path__ + "img/imdb-puppeteer-thumbnail.49304571.png";